import { Getters } from 'vuex-smart-module';
import { DataPilotState } from './state';

export default class DataPilotGetters extends Getters<DataPilotState> {}
